"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtitle = exports.RowContainer = exports.HorizontalContainer = exports.GridContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const Typography_1 = require("../../atoms/Typography");
const HorizontalContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: left;
`;
exports.HorizontalContainer = HorizontalContainer;
const RowContainer = styled_components_1.default.div `
  flex-direction: row;
  gap: 8px;

  @media ${media_1.media.desktop} {
    display: flex;
    align-items: flex-end;
  }
`;
exports.RowContainer = RowContainer;
const Subtitle = (0, styled_components_1.default)(Typography_1.H5) `
  display: inline;
  padding-right: 5px;

  @media ${media_1.media.desktop} {
    display: block;
    color: ${colors_1.gray300};
    text-transform: uppercase;
    width: 120px;
    font-size: 14px;
  }
`;
exports.Subtitle = Subtitle;
const GridContainer = styled_components_1.default.div `
  background: ${colors_1.gray100};
  padding: 6rem 2rem 5.5rem 2rem;
  display: grid;
  width: 100%;
  grid-gap: 10px;

  > :nth-child(1) {
    grid-area: valueLabel;
  }
  > :nth-child(2) {
    grid-area: headerName;
    align-self: center;
  }
  > :nth-child(3) {
    grid-area: profileSensor;
  }
  > :nth-child(4) {
    grid-area: updateOccurance;
  }
  > :nth-child(5) {
    grid-area: actionButtons;
  }

  grid-template-areas:
    "valueLabel headerName"
    "valueLabel profileSensor"
    "valueLabel updateOccurance "
    "valueLabel actionButtons";

  @media ${media_1.media.smallDesktop} {
    padding: 3.5rem 10rem;
  }

  @media ${media_1.media.desktop} {
    padding: 4.5rem 10rem;
    grid-template-columns: 0.2fr 1fr 1fr;
    align-items: center;
    column-gap: 70px;

    > :nth-child(1) {
      grid-area: valueLabel;
    }
    > :nth-child(2) {
      grid-area: headerName;
    }
    > :nth-child(3) {
      grid-area: profileSensor;
    }
    > :nth-child(4) {
      grid-area: updateOccurance;
    }
    > :nth-child(5) {
      grid-area: actionButtons;
    }

    grid-template-areas:
      "valueLabel headerName profileSensor"
      "valueLabel headerName profileSensor"
      "valueLabel updateOccurance actionButtons";
  }
`;
exports.GridContainer = GridContainer;
